<script setup lang="ts">
import {Component} from "../types.ts";
import useStore from "../store.ts";

const props = defineProps<{
  item: Component
}>();

const store = useStore();

const click = async () => {
  if (isNaN(Number(props.item.published.src))) return
  store.layout = Number(props.item.published.src);
};
</script>

<template>
  <div @click=click :id="`${item.published.src}`">
    <div :id="`text-${item.props.id}`" v-html="item.published.src" :style="{position: 'absolute', left: item.text_props?.x_indent ?? 'unset', top: item.text_props?.y_indent ?? 'unset'}">
    </div>
    <slot></slot>
  </div>
</template>

<style scoped>
  div {
    cursor: pointer;
  }
</style>